<template>
  <v-col class="mt-1 pa-0">
    <p style="color: var(--color-text-muted)">
      Recompute the voyage from an updated position and time
    </p>
    <v-row v-if="!noTokensRemaining" no-gutters>
      <v-col :cols="6">
        <ThemedTextField
          label="Longitude"
          outlined
          persistent-placeholder
          type="number"
          class="mr-2"
          :step="0.5"
          v-model="longitudeModel"
        />
      </v-col>
      <v-col :cols="6">
        <ThemedTextField
          label="Latitude"
          outlined
          persistent-placeholder
          type="number"
          :step="0.5"
          v-model="latitudeModel"
        />
      </v-col>
      <v-row no-gutters>
        <v-col :cols="6">
          <v-dialog
            ref="updateDateDialog"
            v-model="updateDateModal"
            width="290px"
            :return-value.sync="dateModel"
          >
            <template v-slot:activator="{ on, attrs }">
              <ThemedTextField
                v-model="dateModel"
                label="Updated date"
                append-icon="mdi-calendar"
                class="mr-2"
                outlined
                readonly
                :rules="[dateFieldRule]"
                persistent-placeholder
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker v-model="dateModel" scrollable :min="earliestDate">
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="updateDateModal = false">
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.updateDateDialog.save(dateModel)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col :cols="6">
          <v-dialog
            ref="updateTimeDialog"
            v-model="updateTimeModal"
            :return-value.sync="timeModel"
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <ThemedTextField
                v-model="timeModel"
                label="Updated time"
                append-icon="mdi-clock-time-four-outline"
                outlined
                persistent-placeholder
                :rules="[timeFieldRule]"
                readonly
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-time-picker v-model="timeModel" full-width>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="updateTimeModal = false">
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.updateTimeDialog.save(timeModel)"
              >
                OK
              </v-btn>
            </v-time-picker>
          </v-dialog>
        </v-col>
      </v-row>
    </v-row>
    <p v-if="showComputationWarning" class="warning-style">
      {{ warningMessage }}
    </p>
  </v-col>
</template>


      
      <script>
import { mapState, mapGetters } from "vuex";
import ThemedTextField from "../../../../../../core/ThemedTextField.vue";
export default {
  name: "RecomputeVoyageDialogContent",
  components: {
    ThemedTextField,
  },
  props: {
    validateForm: Function,
  },
  data: function () {
    return {
      updateDateModal: false,
      updateTimeModal: false,
      dateFieldRule: () => {
        return this.time != null || "Select arrival time";
      },
      timeFieldRule: () => {
        return this.date != null || "Select arrival date";
      },
      earliestDate: null,
    };
  },
  mounted() {
    this.earliestDate = this.date;
  },
  computed: {
    ...mapState("weatherRouting/voyageDetailsModule", [
      "latitude",
      "longitude",
      "date",
      "time",
    ]),
    ...mapGetters("weatherRouting", [
      "showComputationWarning",
      "noTokensRemaining",
    ]),
    latitudeModel: {
      get() {
        return this.latitude;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/voyageDetailsModule/SET_LATITUDE",
          value,
          { root: true }
        );
      },
    },
    longitudeModel: {
      get() {
        return this.longitude;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/voyageDetailsModule/SET_LONGITUDE",
          value,
          { root: true }
        );
      },
    },
    dateModel: {
      get() {
        return this.date;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/voyageDetailsModule/SET_DATE",
          value,
          { root: true }
        );
      },
    },
    timeModel: {
      get() {
        return this.time;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/voyageDetailsModule/SET_TIME",
          value,
          { root: true }
        );
      },
    },
    warningMessage() {
      if (this.noTokensRemaining) {
        return "Warning : You have used all of your computation tokens.Contact us for renewal";
      }
      return "Warning : You have used 90% of your total computation tokens";
    },
  },
};
</script>